import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { LinkLiabilitiesToReoStepComponent } from "../../wizard/wizard-steps/link-liabilities-to-reo-step/link-liabilities-to-reo-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class LinkLiabilitiesToReoStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = LinkLiabilitiesToReoStepComponent;
  }
}
